// Import React and CSS
import './Home.css';
import Hero from "./components/Hero";
import Gallery from "./Gallery";
import Testimonial from "./components/Testimonial";
import JourneyValues from "./components/Journeyvalues";
import EveSection1 from "./components/Eve-Section1";
import EveSection2 from './components/Eve-Section2';
import EveSection3 from './components/Eve-Section3';
import EveSection4 from './components/Eve-Section4';
import EveSection6 from './components/Eve-Section6';
import EveSection5 from './components/Eve-Section5';

// HomePage Component
const Home = () => {
  return (
    <div className="homepage">
      <Hero/>
      <JourneyValues/>
      <EveSection1/>
      <EveSection2/>
      <EveSection3/>
      <EveSection4/>
      <EveSection5/>
      <EveSection6/>
      <Gallery/>
      <Testimonial/>
    </div>
  );
};

export default Home;